<template>
  <div>
    <!--Init de start page-->
    <Start msg/>
  </div>
</template>

<script>
// @ is an alias to /src
import Start from "@/components/Start.vue";

export default {
  name: "home",
  components: {
    Start
  },
  mounted() {
    console.log("App mounted!");
    // we create a variable with the 10 answers in a jsonArray with which we will work
    var answers = [
      {
        q: 1,
        answer: 1
      },
      {
        q: 2,
        answer: 1
      },
      {
        q: 3,
        answer: 1
      },
      {
        q: 4,
        answer: 1
      },
      {
        q: 5,
        answer: 1
      },
      {
        q: 6,
        answer: 1
      },
      {
        q: 7,
        answer: 1
      },
      {
        q: 8,
        answer: 1
      },
      {
        q: 9,
        answer: 1
      },
      {
        q: 10,
        answer: 1
      }
    ];

    // we save the object in the localStorage for later use
    localStorage.setItem("answers", JSON.stringify(answers));
  }
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

